'use strict';

module.exports = function onKeyUp(fn) {
  return function (event) {
    if (event.key == 'Enter') {
      fn(event);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-date-picker/lib/onEnter.js
// module id = 172
// module chunks = 0